module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.6ef9d1aa.png";